import { render, staticRenderFns } from "./EffectivenessDashboardArticle.vue?vue&type=template&id=ea6aaf08&"
import script from "./EffectivenessDashboardArticle.vue?vue&type=script&lang=js&"
export * from "./EffectivenessDashboardArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports